import { DatasetFieldType } from '../../store/types';

export enum Comparator {
    LESS_THAN = '<',
    GREATER_THAN = '>',
    LESS_OR_EQUAL = '<=',
    GREATER_OR_EQUAL = '>=',
    EQUAL = '=',
    NOT_EQUAL = '<>'
}

export interface TextFilterType {
    value: string | null;
    isFuzzyMatchFilter: boolean;
}

export interface NumberFilterType {
    value: number | undefined;
    comparator: Comparator | null;
}

export interface DateFilterType {
    from: string | null;
    to: string | null;
}

export interface TimeFilterType {
    city: string[] | null;
    value: string | null;
    comparator: Comparator | null;
}

export interface ValuationPercentageFilterType {
    containsMaturity: boolean | undefined;
    percentage: number | undefined;
    comparator: Comparator | null;
}

export interface CurrencyFilterType extends NumberFilterType {
    currency: string[] | null;
}

export type InstanceTableFilterType = string[] | TextFilterType | NumberFilterType | boolean | TimeFilterType | DateFilterType | ValuationPercentageFilterType | CurrencyFilterType;

interface InstanceBaseFieldTableFilter {
    fieldId: string;
}

export interface InstanceDropdownFieldTableFilter extends InstanceBaseFieldTableFilter {
    type: DatasetFieldType.DROPDOWN;
    filter: string[];
}

export interface InstanceTextFieldTableFilter extends InstanceBaseFieldTableFilter {
    type: DatasetFieldType.TEXT | DatasetFieldType.LONGTEXT | DatasetFieldType.WYSIWYG;
    filter: TextFilterType;
}

export interface InstanceDateFieldTableFilter extends InstanceBaseFieldTableFilter {
    type: DatasetFieldType.DATE;
    filter: DateFilterType;
}

export interface InstanceNumberFieldTableFilter extends InstanceBaseFieldTableFilter {
    type: DatasetFieldType.NUMBER;
    filter: NumberFilterType;
}

export interface InstanceTimeFieldTableFilter extends InstanceBaseFieldTableFilter {
    type: DatasetFieldType.TIME;
    filter: TimeFilterType;
}

export interface InstanceCheckboxFieldTableFilter extends InstanceBaseFieldTableFilter {
    type: DatasetFieldType.CHECKBOX;
    filter: boolean;
}

export interface InstanceValuationPercentageFieldTableFilter extends InstanceBaseFieldTableFilter {
    type: DatasetFieldType.VALUATION_PERCENTAGE;
    filter: ValuationPercentageFilterType;
}

export interface InstanceCurrencyFieldTableFilter extends InstanceBaseFieldTableFilter {
    type: DatasetFieldType.CURRENCY_AMOUNT;
    filter: CurrencyFilterType;
}

export type InstanceFieldTableFilter = InstanceDropdownFieldTableFilter | InstanceTextFieldTableFilter | InstanceDateFieldTableFilter | InstanceNumberFieldTableFilter | InstanceTimeFieldTableFilter | InstanceCheckboxFieldTableFilter | InstanceValuationPercentageFieldTableFilter | InstanceCurrencyFieldTableFilter;

export interface InstanceTableFilter {
    parentFieldId: string;
    datasetId: number;
    filters: InstanceFieldTableFilter[];
}
